import RequiredIndicator from "@base/ui/RequiredIndicator";
import { useDatePickerContext } from "@ark-ui/react";
import type { PropsWithChildren } from "react";
import { useDatePickerCustomContext } from "../DatePickerContext";

type LabelProps = Omit<React.LabelHTMLAttributes<HTMLLabelElement>, "className">;
type Props = PropsWithChildren<LabelProps>;

const Label = ({ children, ...rest }: Props) => {
  const { getControlProps } = useDatePickerContext();
  const { required } = useDatePickerCustomContext();
  const { id } = getControlProps();

  return (
    <label htmlFor={id} {...rest} className="text-label2">
      {children} {required && <RequiredIndicator />}
    </label>
  );
};

export default Label;
